import React, { useMemo } from 'react';
import { Alert } from './styledComponents';

const TimedBanner = ({ startDate, endDate, type = 'warning', fixed = false, children }) => {
  const isVisible = useMemo(() => {
    // At least one of the dates must be provided
    if (!startDate && !endDate) {
      return false;
    }

    const now = Date.now();
    let validStartDate = true;
    let validEndDate = true;

    if (startDate) {
      const start = Date.parse(startDate);
      validStartDate = !isNaN(start) && now >= start;
    }

    if (endDate) {
      const end = Date.parse(endDate);
      validEndDate = !isNaN(end) && now <= end;
    }

    return validStartDate && validEndDate;
  }, [startDate, endDate]);

  if (!isVisible) {
    return null;
  }

  return (
    <Alert type={type} fixed={fixed}>
      {children}
    </Alert>
  );
};

export { TimedBanner };
